import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { GET_BOOKINGS_LIST, GET_BOOKINGS_LIST_ERROR, GET_BOOKINGS_LIST_SUCCESS } from '../../../actions.js';

function* getBookingsList({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/get-card-details/${payload?.params?.card_type ?? ''}`,
      method: 'GET',
      headers: {
        ...filteredHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_BOOKINGS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_BOOKINGS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_BOOKINGS_LIST_ERROR, payload: error });
  }
}

export function* watchGetBookingsList() {
  yield takeEvery(GET_BOOKINGS_LIST, getBookingsList);
}

function* getBookingsListSaga() {
  yield all([fork(watchGetBookingsList)]);
}

export default getBookingsListSaga;
